<script>
import {Dialog} from "element-ui";

export default {
  name: "CommonDialog",
  extends: Dialog,
  props: {
    border: {
      type: Boolean,
      default: true,
    }
  },

  mounted() {
    let dom = this.$el.children[0].lastChild
    if (this.border) {
      dom.style = " border-top: 1px solid #a3ddf1;"
    }
  }
}
</script>

<style scoped>
/*dialog样式*/
/deep/ .el-dialog__header {
  text-align: center;
  background-color: #E9F6F9;
  background-size: 100%;
  padding: 20px;
  font-weight: bold;
  font-size: 20px;
}

/deep/ .el-dialog__body {
  background-image: url("/static/images/trianglebackground.jpg");
  background-size: cover;
  padding: 20px;
  font-size: 15px;
  line-height: 1.8;
}

/deep/ .el-dialog__footer {
  padding: 20px;
  /*解决浮动的元素导致坍塌问题*/
  overflow: auto;
  background-image: url("/static/images/trianglebackground.jpg");
  background-size: cover;
}

</style>



// WEBPACK FOOTER //
// src/components/custom/CommonDialog.vue